import React from 'react'
import PropTypes from 'prop-types'

import { Container, StepCurrent, StepDone } from './styles'

const Stepper = ({ total, current, ...rest }) => (
  <Container {...rest}>
    <StepDone current={current} total={total} />
    <StepCurrent current={current} total={total} />
  </Container>
)

Stepper.defaultProps = {
  current: 0,
  total: 1,
}

Stepper.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
}

export default Stepper
